/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Editedby1Inputs */

const de__field_editedby1 = /** @type {(inputs: _Field_Editedby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bearbeitet von`)
};

/**

* @param {_Field_Editedby1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_editedby1 = /** @type {((inputs?: _Field_Editedby1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Editedby1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_editedby1(inputs)
});
export { _field_editedby1 as "_field_editedBy" }